<template>
	<section id="linkedProjects" v-if="projects">
    <header>
      <h2>{{ $t("otherProjects") }}</h2>
    </header>
    <div class="grid c-3">
      <article v-for="project in projects" :key="project.uid">
        <router-link :to="{ path: $route.meta[currentLang+'Path']+'/'+project.uid, params: { id: project.uid } }" > 
          <figure class="small-thumb" v-if="project.thumbCover">
            <img class="toLoad" 
              v-if="project.thumbCover.extension != 'gif'" 
              v-lazy="project.thumbCover.thumb" 
              :src="project.thumbCover.src"
              :srcset="project.thumbCover.srcset"
              sizes="100vw, (min-width: 768px) 50vw, (min-width: 1040px) 50vw"
              :key="project.uid" 
              :alt="project.thumbCover.alt"
              @load="displayImage($event)"/>
              <img class="toLoad" 
                v-else 
                :src="project.thumbCover.url" 
                :alt="project.thumbCover.alt"
                @load="displayImage($event)"
               />
          </figure>
          <div class="infos">
            <h1 class="title-regular">{{ project.title }}</h1>
            <div class="subtitle" v-html="project.additionalInformations"></div>
          </div>
        </router-link>
      </article>
    </div>
	</section>
</template>

<script>


export default {
	props: ['projects','currentLang'],
	methods:{
		displayImage(e){
			let el = e.target;
			setTimeout(
				function(){ el.classList = 'loaded';
			}, 500);
		}
	}
}
</script>

<style lang="scss">
  #linkedProjects{
    padding: 5.33333em;
    padding-bottom: 6.666667em;
    h2{
      margin:0 auto 2.666em auto;
      font-size:1.733333em;
    }
    article{
      margin-bottom: 2.6666em;
      .infos{
        margin-top: 1.3333em;
      }
      .infos, .subtitle{
        opacity: 1;
      }

      img{
        transition: transform .5s ease;
        @include transform(scale(1));
      }

      .subtitle{
        font-size: 0.9333333em;
        font-family: 'surtmedium_extended', helvetica, Arial, sans-serif;
        letter-spacing:0.44px;
        color:var(--darkGrey);
        line-height: 1.2;
        opacity: .5;
      }
      &:not(.inactive):hover{
        img{
          @include transform(scale(1.01));
        }
      }

    }

    .grid.c-3 {
      grid-gap: 2em;
    }
    @media screen and (max-width: 768px){
      padding: 2em;
      .grid.c-3 {
          grid-template-columns: repeat(1, 1fr);
      }
    }
  }
</style>